import React, { useState } from 'react';
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';
import { Box, useTheme, useMediaQuery } from '@mui/material';
import DashBoardNavBar from '../components/DashBoardNavBar.tsx';
import Navbar from '../components/Navbar.tsx';
import LeftPanel from '../components/LeftPanel.tsx';
import ContentLeaderboard from '../components/ContentLeaderboard.tsx';

const TopContents: React.FC = () => {
  const isAuthenticated = !!Cookies.get('token');
  const navigate = useNavigate();
  const theme = useTheme();
  
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [leftPanelOpen, setLeftPanelOpen] = useState(false);

  const leftPanelWidth = isMobile ? 0 : (leftPanelOpen ? 240 : 56);
  const topPadding = isMobile ? '112px' : '80px';

  const handlePanelAction = (path: string) => {
    if (path === '/learning') {
      navigate('/learning');
    } else if (!isAuthenticated) {
      navigate('/login');
    } else {
      navigate(path);
    }
  };

  return (
    <Box sx={{ 
      display: 'flex', 
      flexDirection: 'column', 
      minHeight: '100vh',
      width: '100%',
      overflowX: 'hidden',
      backgroundColor: theme.palette.background.default
    }}>
      {/* Fő Navigáció */}
      {isAuthenticated ? <DashBoardNavBar /> : <Navbar />}

      {/* Bal / Felső Panel */}
      <LeftPanel
        isAuthenticated={isAuthenticated}
        onLoginRequired={() => navigate('/login')}
        onNavigation={handlePanelAction} 
        open={leftPanelOpen}
        onToggle={() => setLeftPanelOpen(prev => !prev)}
      />

      {/* Fő tartalom terület */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          // Ez a rész felel a vízszintes középre igazításért:
          alignItems: 'center', 
          width: '100%',
          paddingTop: topPadding,
          // A marginLeft és a szélesség korrekciója a panel miatt
          paddingLeft: { xs: 0, sm: `${leftPanelWidth}px` }, 
          transition: theme.transitions.create(['padding-left'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
          }),
          boxSizing: 'border-box',
        }}
      >
        {/* Konténer a LeaderBoard köré, ami garantálja a középre rendezést */}
        <Box sx={{ 
          width: '100%', 
          maxWidth: '1200px', // Opcionális: ne legyen túl széles nagy monitoron
          display: 'flex',
          justifyContent: 'center'
        }}>
          <ContentLeaderboard />
        </Box>
      </Box>
    </Box>
  );
};

export default TopContents;